/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Action_ContinueInputs */

const en_us2_search_action_continue = /** @type {(inputs: Search_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue workout`)
};

const pt_br2_search_action_continue = /** @type {(inputs: Search_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar treino`)
};

const es_419_search_action_continue = /** @type {(inputs: Search_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar entrenamiento`)
};

const pt_pt2_search_action_continue = /** @type {(inputs: Search_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar treino`)
};

const fr_fr2_search_action_continue = /** @type {(inputs: Search_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprendre la séance`)
};

const de_de2_search_action_continue = /** @type {(inputs: Search_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training fortsetzen`)
};

const it_it2_search_action_continue = /** @type {(inputs: Search_Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua allenamento`)
};

/**
* | output |
* | --- |
* | "Continue workout" |
*
* @param {Search_Action_ContinueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_continue = /** @type {((inputs?: Search_Action_ContinueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_ContinueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_continue(inputs)
	if (locale === "es-419") return es_419_search_action_continue(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_continue(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_continue(inputs)
	if (locale === "de-DE") return de_de2_search_action_continue(inputs)
	if (locale === "it-IT") return it_it2_search_action_continue(inputs)
	return en_us2_search_action_continue(inputs)
});
export { search_action_continue as "search.action_continue" }